<template>
    <div class="contentSelection" v-if="dataItem && dataItem.length > 0">
        <!--1课程，2图文，3视频，4直播，5近期活动，6就诊指南，7临床招募，8公益救助，9学知识/疾病库，
              10战友故事，11诊断送诊，12公益行动跳转连接，13音频，14抗癌百科，15科普手册，16专题 -->
        <div v-for="(item, index) in dataItem" :key="index">
            <Article v-if="item.type === 2" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Lives v-else-if="item.type === 4" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Activity v-else-if="item.type === 5" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Videos v-else-if="item.type === 3" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Guide v-else-if="item.type === 6" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Clinic v-else-if="item.type === 7" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Community v-else-if="item.type === 8" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Knowledge v-else-if="item.type === 9" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Comrade v-else-if="item.type === 10" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Diagnose v-else-if="item.type === 11" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Anticancer v-else-if="item.type === 14" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Manual v-else-if="item.type === 15" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
            <Special v-else-if="item.type === 16" :dataItem="item" :contentType="contentType" :searchText="searchText"/>
        </div>
    </div>
</template>

<script>
import {
    Manual,
    Lives,
    Videos,
    Article,
    Activity,
    Guide,
    Clinic,
    Community,
    Knowledge,
    Comrade,
    Diagnose,
    Anticancer,
    Special
} from './index.js'

export default {
    name: 'contentSelection',
    components: {
        Guide,
        Manual,
        Lives,
        Videos,
        Article,
        Activity,
        Clinic,
        Community,
        Knowledge,
        Comrade,
        Diagnose,
        Anticancer,
        Special
    },
    props: {
        dataItem: {
            type: Array,
            default: () => [],
            required: true
        },
        contentType: {
            type: Number,
            default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/contentSelection/index.vue